/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Loading_Sync_TitleInputs */



/**
* | output |
* | --- |
* | "Synchronizing space..." |
*
* @param {Spaces_Wizard_Loading_Sync_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_loading_sync_title = /** @type {((inputs?: Spaces_Wizard_Loading_Sync_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Loading_Sync_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space wird synchronisiert...")
	return /** @type {LocalizedString} */ ("Synchronizing space...")
});